import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CompanyService } from 'app/company/services/company.service';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/core/services/user.service';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ActivatedRoute } from '@angular/router';
import { CompanyUserListModel } from 'app/company/models/company-user-list-model';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';
import { UserType } from '../../../account/models/user-type.model';
import { CompanyUser } from '../../../account/models/company-user.model';
import { Result } from 'app/core/models/result';
import { User } from '../../../shared/models/User';
import { CompanyUserModel } from '../../../shared/models/company-user.model';

@Component({
	selector: 'app-company-users',
	templateUrl: './company-users.component.html',
	styleUrls: ['./company-users.component.css']
})
export class CompanyUsersComponent implements OnInit {
    user: User;
    isAdmin: boolean = false;
    headerTitle: IHeaderTitle;
    @Input() companyId: string;
    companyDetailsModel: CompanyDetailsModel;
    selectedUserId: string;
	users: CompanyUserListModel[];
    userList: CompanyUserListModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;
    isUserAddMode = false;
    isEditMode: boolean = false;
    userTypes: UserType[];
    showUpdated: boolean;
    errors: string[];

	constructor(
        private _companyService: CompanyService,
        private sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private fb: FormBuilder,
        private sortService: SortService,
        private userService: UserService
	) { }

	ngOnInit() {

        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.isAdmin = this.user.isAdmin;
        });

        this.load();

        this._companyService.get(this.companyId).subscribe(companyInfo => {
            this.companyDetailsModel = companyInfo;
            if (this.isAdmin) {
                this.headerTitle = {
                    title: companyInfo.legalName + ' Company Existing Users',
                    breadcrumbs: [{ title: 'Companies', url: ['/company'] }]
                };
            } else {
                this.headerTitle = {
                    title: companyInfo.legalName + ' Company Existing Users',
                };
            }
        });
        this.userService.getUserTypes().subscribe(
            userTypes => this.userTypes = userTypes,
            error => {
                console.log(error);
            }
        );
	}

	companyUserAdded($event: string): void {
		this.load();
	}

	load(): void {
        this._companyService.getUsers(this.companyId).subscribe(
            users => {
                this.users = users,
                this.userList = users
            },
			error => console.log(error)
		);

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.userList = this.sortService.filterAndSortlist(this.users, newValue, this.lastSort);
        });
	}

	deleteUser() {
        this._companyService.deleteUser(this.selectedUserId).subscribe(
			result => this.load(),
			error => console.log(error)
		);
    }

    updateCompanyUserType(user: CompanyUserModel, value: number) {
        console.log(user);
        if (user.userTypeId == value) {
            return;
        }

        let companyUser: CompanyUser = {
            id: user.companyUserId,
            companyId: 'b6a058ec-3cd3-456a-ae1f-08d7d4fa78bd', /* Guids must be passed through for model validation, but aren't used by service */
            siteUserId: 'b6a058ec-3cd3-456a-ae1f-08d7d4fa78bd',
            userTypeId: value
        }

        this.userService.updateCompanyUserType(companyUser).subscribe(
            result => {
                this.load();
                this.showUpdated = true;
                setTimeout(() => {
                    this.showUpdated = false;
                }, 5000);
            },
            error => this.errors = (<Result>error).errorList
        );
    }

    toggleUserAddMode(): void {
        this.isUserAddMode = !this.isUserAddMode;
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    onBack($event: any): void {
        this.location.back();
    }
}
